import type { BackendError, ErrorKey } from '@/helpers/errors/collection'
import { type Email, isValidEmail } from '@/types/email'
import {
    type FrontendError,
    useFrontendError,
} from '@/composables/useFrontendError'
import type { Ref } from 'vue'
import { useI18n } from 'vue-i18n'

export function useEmailError(
    email: Readonly<Ref<string>>,
    path: ErrorKey[]
): FrontendError<Email> {
    const { t } = useI18n()

    const emailEmptyError: BackendError = {
        message: t('globals.empty_email_error'),
        path,
        isInternalServerError: false,
        isUnauthorized: false,
    }

    const emailInvalidError: BackendError = {
        message: t('globals.invalid_email_error'),
        path,
        isInternalServerError: false,
        isUnauthorized: false,
    }

    return useFrontendError(email, (value) => {
        if (!value) {
            return {
                valid: false,
                error: emailEmptyError,
            }
        }

        if (!isValidEmail(value)) {
            return {
                valid: false,
                error: emailInvalidError,
            }
        }

        return {
            valid: true,
            value: value,
        }
    })
}
